import { render, staticRenderFns } from "./IndexForm.html?vue&type=template&id=4e5f0e16&scoped=true&"
import script from "./IndexForm.js?vue&type=script&lang=js&"
export * from "./IndexForm.js?vue&type=script&lang=js&"
import style0 from "./IndexForm.scss?vue&type=style&index=0&id=4e5f0e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f0e16",
  null
  
)

export default component.exports